"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _seleceSalegoods = _interopRequireDefault(require("./seleceSalegoods.vue"));
var _saleLog = _interopRequireDefault(require("./saleLog.vue"));
var _nextState = _interopRequireDefault(require("./nextState.vue"));
var _static = require("../orderList/order/static");
var _static2 = require("./static");
var _TransportTrace = _interopRequireDefault(require("../orderList/order/components/TransportTrace.vue"));
var _DutyContent = _interopRequireDefault(require("./DutyContent.vue"));
var _orderDetail = _interopRequireDefault(require("../orderList/order/lists/orderDetail.vue"));
var _debounce = _interopRequireDefault(require("@/libs/debounce.js"));
var _systemSetting = require("@/api/systemSetting.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var PROOF_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
var PROOF_IMAGE_TYPES = ['image/jpeg', 'image/png'];
var PROOF_IMAGE_FORMAT_MESSAGE = '仅支持 JPG、JPEG、PNG 格式图片！';
var _default = exports.default = {
  components: {
    SeleceSalegoods: _seleceSalegoods.default,
    SaleLog: _saleLog.default,
    NextState: _nextState.default,
    TransportTrace: _TransportTrace.default,
    DutyContent: _DutyContent.default,
    OrderDetail: _orderDetail.default
  },
  data: function data() {
    return {
      refundMsgOption: _static2.refundMsgOption,
      changeMsgOption: _static2.changeMsgOption,
      orderStateOption: _static.orderStateOption,
      compensationTypeOption: _static2.compensationTypeOption,
      paymentMethodOption: [{
        value: 1,
        label: '现金'
      }, {
        value: 2,
        label: '福豆'
      }],
      saleTypeOption: [],
      pram: {
        proofImages: [],
        notifyType: [],
        couponId: [],
        cashRefund: false,
        maxCash: 0,
        cash: 0,
        freightRefund: false,
        freightRefundAmount: 0,
        aftersaleType: null,
        // Initialize with null to prevent undefined errors
        compensationType: '',
        compensationAmount: 0,
        // 赔付金额，福豆数量
        compensationRemark: '',
        isAudited: 0,
        // 默认无需审核
        pickUpAddressId: null,
        // 京东/山姆换货：收货地址
        backAddressId: null,
        // 京东/山姆退货/换货：取货地址
        pickUpType: null // 京东/山姆退货信息：取件方式
      },
      messageOption: [{
        value: 1,
        name: '短信通知顾客'
      }, {
        value: 2,
        name: '微信通知顾客'
      }],
      aftersaleNo: '',
      // 售后单号
      orderNo: '',
      // 订单号
      currentOrderNo: '',
      // 当前使用的订单号
      searchOrderNo: null,
      // 查询的订单号
      handerType: 0,
      // 0: 创建售后 1: 审核售后 2: 售后明细
      isDisabled: false,
      showProofImageUploader: false,
      proofImageUploadingCount: 0,
      proofImageDragActive: false,
      proofImageLimitWarningVisible: false,
      loadingInfo: {
        createLoading: false,
        examineLoading: false,
        goNextLoading: false
      },
      // 审核驳回弹窗
      rejectDialog: {
        visible: false,
        adminReason: ''
      },
      orderDetailInfo: {},
      // 订单详情
      aftersaleDetails: {},
      // 售后详情
      initLoading: false,
      orderInitLoading: false,
      fucardLists: [],
      checkFucard: [],
      cshCardRequest: {
        cash: 0,
        fuCard: []
      },
      supplierPercentage: 0,
      // 供应商承担比例
      customerPercentage: 0,
      // 客户承担比例
      platformPercentage: 0,
      // 平台承担比例
      totalAmount: 0,
      // 售后成本总额
      supplierAmount: 0,
      customerAmount: 0,
      platformAmount: 0,
      aftersaleCostAmount: 0,
      currentitem: [],
      returnShopIntegralDesc: null,
      integralConfirmDialog: {
        visible: false
      },
      merchantAddressOptions: [],
      merchantAddressLoading: false,
      selectedSkuIds: [] // 当前勾选的商品 skuId 列表，用于动态计算 pickUpTypeOptions
    };
  },
  computed: {
    isOneCardRightOrder: function isOneCardRightOrder() {
      return Boolean(this.orderDetailInfo && this.orderDetailInfo.oneCardInstanceCardId);
    },
    isLypOrderType: function isLypOrderType() {
      var t = Number(this.orderDetailInfo && this.orderDetailInfo.type);
      return t === 80 || t === 81;
    },
    isMultiMerchantOrder: function isMultiMerchantOrder() {
      var t = Number(this.orderDetailInfo && this.orderDetailInfo.type);
      return t === 100 || t === 101 || t === 102;
    },
    // 是否需要填写售后数量和售后金额（仅退款/退货退款时需要）
    isNeedQtyAndAmount: function isNeedQtyAndAmount() {
      var aftersaleType = this.handerType === 0 ? this.pram.aftersaleType : this.aftersaleDetails.aftersaleType;
      return [1, 3].includes(Number(aftersaleType));
    },
    goodsSourceText: function goodsSourceText() {
      var t = Number(this.orderDetailInfo && this.orderDetailInfo.type);
      if (t === 80) return '京东商品';
      if (t === 81) return '山姆商品';
      return '--';
    },
    orderOption: function orderOption() {
      var baseMap = {
        0: _static2.createSaleOption,
        1: _static2.examintBaseOption,
        2: _static2.saleRecordOption
      };
      var baseOption = baseMap[this.handerType] || _static2.createSaleOption;
      // 找到福豆(useIntegral)的位置，在其后插入返积分/积分抵扣
      var useIntegralIndex = baseOption.findIndex(function (item) {
        return item.dataIndex === 'useIntegral';
      });
      if (useIntegralIndex === -1) return baseOption;
      var insertItem = this.orderDetailInfo && this.orderDetailInfo.isShopIntegralOrder === 1 ? {
        title: '积分抵扣',
        dataIndex: 'payShopIntegral',
        isWarning: true
      } : {
        title: '返积分',
        dataIndex: 'giveIntegral'
      };
      return [].concat(_toConsumableArray(baseOption.slice(0, useIntegralIndex + 1)), [insertItem], _toConsumableArray(baseOption.slice(useIntegralIndex + 1)));
    },
    pickUpTypeOptions: function pickUpTypeOptions() {
      var _this = this;
      var pickUpTypeMap = {
        1: '上门取件',
        3: '客户发货'
      };
      var allInfos = this.orderDetailInfo && this.orderDetailInfo.lypAftersaleInfos || [];
      // 有选中商品时只取选中商品对应的 infos；否则取全量
      var infos = this.selectedSkuIds.length ? allInfos.filter(function (info) {
        return _this.selectedSkuIds.includes(String(info.skuId));
      }) : allInfos;
      if (!infos.length) {
        return Object.keys(pickUpTypeMap).map(function (k) {
          return {
            value: Number(k),
            label: pickUpTypeMap[k]
          };
        });
      }
      var arrays = infos.map(function (item) {
        return (item.supportedPickupTypes || []).map(Number);
      });
      var intersection = arrays[0].filter(function (v) {
        return arrays.every(function (arr) {
          return arr.includes(v);
        });
      });
      return intersection.map(function (v) {
        return {
          value: v,
          label: pickUpTypeMap[v] || String(v)
        };
      });
    },
    filteredSaleTypeOption: function filteredSaleTypeOption() {
      var _this2 = this;
      return (this.saleTypeOption || []).filter(function (item) {
        return Number(item.code) !== 4 && (!_this2.isLypOrderType || Number(item.code) !== 2);
      });
    },
    showReturnShopIntegral: function showReturnShopIntegral() {
      return this.returnShopIntegralDesc !== null && this.returnShopIntegralDesc !== undefined;
    },
    isReturnShopIntegralBlocked: function isReturnShopIntegralBlocked() {
      return this.returnShopIntegralDesc === '该订单不可退积分';
    },
    remainIntegral: function remainIntegral() {
      return this.orderDetailInfo.remainIntegral !== undefined && this.orderDetailInfo.remainIntegral !== null ? this.orderDetailInfo.remainIntegral : null;
    }
  },
  created: function created() {
    var _this3 = this;
    this.getSaleType();
    var _this$$route$params = this.$route.params,
      aftersaleNo = _this$$route$params.aftersaleNo,
      type = _this$$route$params.type,
      orderNo = _this$$route$params.orderNo;
    this.aftersaleNo = aftersaleNo;
    this.orderNo = orderNo;
    this.orderDetailInfo = {};
    this.initLoading = false;
    this.currentOrderNo = orderNo ? orderNo : null;
    this.handerType = Number(type);
    orderNo && this.getOrderDetail(orderNo);
    aftersaleNo && this.getAftersaleDetail();
    // 成功获取订单详情后再获取退款信息
    orderNo && this.getOrderDetail(orderNo).then(function (res) {
      if (res && _this3.handerType === 0) {
        _this3.getRefundDetail(orderNo);
      }
    });
  },
  mounted: function mounted() {
    // 使用防抖处理保存和审核方法
    this.debouncedSaveCreateSale = (0, _debounce.default)(this._saveCreateSale, 1000);
    this.debouncedExamineSale = (0, _debounce.default)(this._examineSale, 1000);
    window.addEventListener('paste', this.handleProofImagePaste);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('paste', this.handleProofImagePaste);
  },
  methods: {
    transformState: _transformState.default,
    // 处理售后类型变更
    handleAftersaleTypeChange: function handleAftersaleTypeChange(value) {
      var _this4 = this;
      console.log('售后类型变更:', value);
      // 如果不是赔付类型，重置赔付相关字段
      if (value !== 4) {
        this.pram.compensationType = '';
        this.pram.compensationAmount = 0;
        this.pram.compensationRemark = '';
      } else {
        // 如果是赔付类型，设置为无需审核
        this.pram.isAudited = 0;
        // 清空售后原因，因为赔付使用单独的说明字段
        this.pram.reason = '';

        // 延迟执行，确保DOM已更新
        this.$nextTick(function () {
          // 如果是赔付类型，移除审核和售后原因的校验
          if (_this4.$refs['createForm']) {
            _this4.$refs['createForm'].clearValidate(['isAudited', 'reason']);
          }

          // 更新 SeleceSalegoods 组件，应用赔付类型的特殊处理
          if (_this4.$refs['SeleceSalegoodsRef']) {
            // 由于已经在模板中绑定了 isCompensationType 属性，这里不需要额外设置
            // 在商品列表中应用必要的变更
            _this4.$refs['SeleceSalegoodsRef'].selectIds.forEach(function (item) {
              // 禁用输入但保留选择状态
              _this4.$set(item, 'saleQty', 1);
              _this4.$set(item, 'saleAmount', 0);
            });
          }
        });
      }
    },
    // 获取赔付类型标签
    getCompensationTypeLabel: function getCompensationTypeLabel(value) {
      var item = _static2.compensationTypeOption.find(function (item) {
        return item.value === value;
      });
      return item ? item.label : '--';
    },
    // 凭证相关
    handleDragStart: function handleDragStart(e, item) {
      // 移动
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.pram.proofImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.pram.proofImages = newItems;
      }
    },
    // 本地售后凭证上传前校验
    showProofImageLimitWarning: function showProofImageLimitWarning() {
      var _this5 = this;
      if (this.proofImageLimitWarningVisible) return;
      this.proofImageLimitWarningVisible = true;
      this.$message({
        message: '最多上传10张图片，超出数量的图片已自动忽略！',
        type: 'warning',
        onClose: function onClose() {
          _this5.proofImageLimitWarningVisible = false;
        }
      });
    },
    beforeProofImageUpload: function beforeProofImageUpload(file) {
      if (!this.isSupportedProofImage(file)) {
        this.$message.warning(PROOF_IMAGE_FORMAT_MESSAGE);
        return false;
      }
      if (file.size > PROOF_IMAGE_MAX_SIZE) {
        this.$message.warning('请上传文件大小≤ 5MB！');
        return false;
      }
      if (this.pram.proofImages.length + this.proofImageUploadingCount >= 10) {
        this.showProofImageLimitWarning();
        return false;
      }
      this.proofImageUploadingCount += 1;
      return true;
    },
    isSupportedProofImage: function isSupportedProofImage(file) {
      if (!file) return false;
      if (file.type) return PROOF_IMAGE_TYPES.includes(file.type.toLowerCase());
      return /\.(jpe?g|png)$/i.test(file.name || '');
    },
    uploadProofImageFiles: function uploadProofImageFiles(files) {
      var fileList = Array.from(files || []);
      if (!fileList.length) {
        this.$message.warning(PROOF_IMAGE_FORMAT_MESSAGE);
        return;
      }
      for (var _i = 0, _fileList = fileList; _i < _fileList.length; _i++) {
        var file = _fileList[_i];
        if (this.pram.proofImages.length + this.proofImageUploadingCount >= 10) {
          this.showProofImageLimitWarning();
          break;
        }
        if (this.beforeProofImageUpload(file)) {
          this.handleProofImageUpload({
            file: file
          });
        }
      }
    },
    handleProofImagePaste: function handleProofImagePaste(event) {
      if (!this.showProofImageUploader || this.handerType !== 0 || this.isDisabled || Number(this.pram.aftersaleType) === 4) return;
      var target = event.target;
      if (target && (['INPUT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable)) return;
      var items = event.clipboardData && event.clipboardData.items;
      var files = items ? Array.from(items).filter(function (item) {
        return item.kind === 'file';
      }).map(function (item) {
        return item.getAsFile();
      }).filter(Boolean) : [];
      if (!files.length) {
        this.$message.warning('剪贴板中未检测到可上传的图片，请重新复制后粘贴！');
        return;
      }
      event.preventDefault();
      this.uploadProofImageFiles(files);
    },
    handleProofImageDragEnter: function handleProofImageDragEnter() {
      if (!this.dragging) this.proofImageDragActive = true;
    },
    handleProofImageDragLeave: function handleProofImageDragLeave() {
      this.proofImageDragActive = false;
    },
    handleProofImageDrop: function handleProofImageDrop(event) {
      this.proofImageDragActive = false;
      if (this.dragging) return;
      this.uploadProofImageFiles(event.dataTransfer && event.dataTransfer.files);
    },
    // 上传本地售后凭证
    handleProofImageUpload: function () {
      var _handleProofImageUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options) {
        var file, onSuccess, onError, formData, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file, onSuccess = options.onSuccess, onError = options.onError;
              formData = new FormData();
              formData.append('multipart', file);
              _context.p = 1;
              _context.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, {
                model: 'content',
                pid: 1
              });
            case 2:
              res = _context.v;
              if (!(!res || !res.url)) {
                _context.n = 3;
                break;
              }
              throw new Error('上传接口未返回图片地址');
            case 3:
              this.pram.proofImages.push(res.url);
              if (onSuccess) onSuccess(res);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error("\u56FE\u7247\u4E0A\u4F20\u5931\u8D25\uFF1A".concat(_t && _t.message ? _t.message : '请重试'));
              if (onError) onError(_t);
            case 5:
              _context.p = 5;
              this.proofImageUploadingCount = Math.max(0, this.proofImageUploadingCount - 1);
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function handleProofImageUpload(_x) {
        return _handleProofImageUpload.apply(this, arguments);
      }
      return handleProofImageUpload;
    }(),
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) {
        this.dragging = null;
      }
      ;
    },
    handleRemove: function handleRemove(i) {
      this.pram.proofImages.splice(i, 1);
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push(this.orderNo && this.handerType == 0 ? '/order/orderList/lists' : "/order/aftersale");
    },
    // 防抖处理的创建售后方法包装
    saveCreateSale: function saveCreateSale() {
      if (this.proofImageUploadingCount > 0) {
        this.$message.warning('售后凭证正在上传，请稍候！');
        return;
      }
      this.debouncedSaveCreateSale();
    },
    // 原始创建售后方法
    _saveCreateSale: function _saveCreateSale() {
      var _this6 = this;
      // 商品选择配置 - 对于所有类型都需要选择商品，但对于赔付类型不验证数量和金额
      var outSelect = [];
      outSelect = this.$refs['SeleceSalegoodsRef'].outPutSelect() || [];
      if (!outSelect.length) {
        this.$message({
          message: '请选择售后商品！',
          type: 'warning',
          duration: 5000 // 设置显示时间为5秒
        });
        return;
      }

      // 校验售后类型是否已选择
      if (!this.pram || this.pram.aftersaleType === null || this.pram.aftersaleType === undefined || this.pram.aftersaleType === '') {
        this.$message({
          message: '请选择售后类型！',
          type: 'warning',
          duration: 5000
        });
        return;
      }

      // 商品售后总金额，用于验证（非赔付类型时）
      var totalAfterSaleAmount = outSelect.reduce(function (sum, item) {
        var itemAmount = Number(item.saleAmount) || 0;
        return sum + itemAmount;
      }, 0);

      // 如果是赔付类型，则仅验证赔付的必填字段
      if (this.pram && this.pram.aftersaleType === 4) {
        if (!this.pram.compensationType) {
          this.$message({
            message: '请选择赔付类型！',
            type: 'warning',
            duration: 5000
          });
          return;
        }
        if (this.pram.compensationAmount === undefined || this.pram.compensationAmount === null || this.pram.compensationAmount <= 0) {
          this.$message({
            message: '请输入有效的福豆赔付数量！',
            type: 'warning',
            duration: 5000
          });
          return;
        }
        if (!this.pram.compensationRemark) {
          this.$message({
            message: '请输入赔付说明！',
            type: 'warning',
            duration: 5000
          });
          return;
        }
        this.submitSaveForm(outSelect, totalAfterSaleAmount);
      } else {
        // 非赔付类型，校验售后原因
        if (!this.pram.reason || !this.pram.reason.trim()) {
          this.$message({
            message: '请填写售后原因！',
            type: 'warning',
            duration: 5000
          });
          return;
        }
        // 换货类型时校验退货信息和换货收货信息
        if (Number(this.pram.aftersaleType) === 2) {
          if (!this.isLypOrderType) {
            if (!this.pram.supplierAddressRealName) {
              this.$message({
                message: '请填写退货信息-收件人',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (!this.pram.supplierAddressPhone) {
              this.$message({
                message: '请填写退货信息-收件电话',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (!this.pram.supplierAddressDetail) {
              this.$message({
                message: '请填写退货信息-收件地址',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (!this.pram.customerAddressRealName) {
              this.$message({
                message: '请填写换货收货信息-收件人',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (!this.pram.customerAddressPhone) {
              this.$message({
                message: '请填写换货收货信息-收件电话',
                type: 'warning',
                duration: 5000
              });
              return;
            }
            if (!this.pram.customerAddressDetail) {
              this.$message({
                message: '请填写换货收货信息-收件地址',
                type: 'warning',
                duration: 5000
              });
              return;
            }
          }
        }
        // 退货退款类型时校验退货信息
        if (Number(this.pram.aftersaleType) === 1 && !this.isLypOrderType) {
          if (!this.pram.supplierAddressRealName) {
            this.$message({
              message: '请填写退货信息-收件人',
              type: 'warning',
              duration: 5000
            });
            return;
          }
          if (!this.pram.supplierAddressPhone) {
            this.$message({
              message: '请填写退货信息-收件电话',
              type: 'warning',
              duration: 5000
            });
            return;
          }
          if (!this.pram.supplierAddressDetail) {
            this.$message({
              message: '请填写退货信息-收件地址',
              type: 'warning',
              duration: 5000
            });
            return;
          }
        }
        // 非赔付类型，进行表单验证
        // 80/81：退货退款时，后端需要 backAddressId = pickUpAddressId
        // 在校验前先补齐，避免 prop=backAddressId 校验失败
        if (this.isLypOrderType && Number(this.pram.aftersaleType) === 1) {
          this.$set(this.pram, 'backAddressId', this.pram.pickUpAddressId);
        }
        this.$refs['createForm'].validate(function (valid) {
          if (!valid) return;
          // 仅退款/退货退款且全部退款时，检查积分扣除
          if ([1, 3].includes(Number(_this6.pram.aftersaleType))) {
            _this6.checkIntegralDeduction(outSelect, function () {
              _this6.submitSaveForm(outSelect, totalAfterSaleAmount);
            });
          } else {
            _this6.submitSaveForm(outSelect, totalAfterSaleAmount);
          }
        });
      }
    },
    // 提交保存表单的共用方法
    submitSaveForm: function submitSaveForm(outSelect, totalAfterSaleAmount) {
      var _this7 = this;
      this.$set(this.loadingInfo, 'createLoading', true);

      // 声明变量
      var cshCardRequest;
      var compensationRequest = null;

      // 如果是赔付类型，跳过退款金额校验和商品校验
      if (this.pram.aftersaleType && this.pram.aftersaleType == 4) {
        // 处理赔付数据
        compensationRequest = {
          compensationType: this.pram.compensationType,
          compensationAmount: Number(parseFloat(this.pram.compensationAmount).toFixed(2)),
          // 允许小数位，保留两位小数
          compensationRemark: this.pram.compensationRemark || this.pram.reason // 优先使用专门的赔付说明
        };

        // 构建空的退款信息对象，因为赔付不需要退款信息
        cshCardRequest = {
          cash: 0,
          fuCard: []
        };
      } else {
        // 构建 cshCardRequest 对象
        cshCardRequest = {
          cash: this.pram.cashRefund ? this.pram.cash : 0,
          freightRefundAmount: this.pram.freightRefund ? this.pram.freightRefundAmount : 0,
          packingFeeRefundAmount: 0,
          fuCard: this.fucardLists.filter(function (card) {
            return card.checked;
          }) // 只选择被勾选的福豆
          .map(function (card) {
            return {
              fucardId: card.fucardId,
              amount: card.refundNum,
              name: card.name
            };
          })
        };
        var merchantFullRefund = this.isMultiMerchantOrder && this.isMerchantGoodsFullRefund(outSelect);
        if (this.isMultiMerchantOrder && !merchantFullRefund) {
          cshCardRequest.freightRefundAmount = 0;
          this.pram.freightRefund = false;
          this.pram.freightRefundAmount = 0;
        }

        // 计算原路退回信息输入的总金额（多商户商品全退时由后端自动补齐打包费、运费及原路退款构成）
        var totalRefundAmount = cshCardRequest.cash + cshCardRequest.fuCard.reduce(function (sum, card) {
          return sum + card.amount;
        }, 0);
        console.log('原路退回信息输入的总金额:', totalRefundAmount);
        console.log('totalAfterSaleAmount:', totalAfterSaleAmount);

        // 计算商品售后金额 + 退回运费
        var totalAfterSaleWithFreight = totalAfterSaleAmount + cshCardRequest.freightRefundAmount;
        console.log('商品售后金额 + 退回运费:', totalAfterSaleWithFreight);

        // 比较商品选择输入的总金额 + 退回运费与原路退回信息输入的总金额
        if (!this.isOneCardRightOrder && !merchantFullRefund && Math.abs(totalAfterSaleWithFreight - totalRefundAmount) > 0.01) {
          // 使用容差比较浮点数
          this.$message({
            message: '商品选择输入的总金额 + 退回运费必须和原路退回信息输入的总金额相等！',
            type: 'warning',
            duration: 5000 // 设置显示时间为5秒
          });
          this.$set(this.loadingInfo, 'createLoading', false);
          return;
        }
      }
      var totalPercentage = this.supplierPercentage + this.customerPercentage + this.platformPercentage;
      // 检查三个百分比之和是否超过100
      if (totalPercentage > 100) {
        this.$message({
          message: '供应商、客户和平台的百分比之和不能超过100',
          type: 'error',
          duration: 5000 // 设置显示时间为5秒
        });
        this.$set(this.loadingInfo, 'createLoading', false);
        return; // 阻止提交
      }
      var costRequest = {
        orderAftersaleItemRequest: outSelect,
        responsibility: {
          supplierPercentage: this.supplierPercentage,
          customerPercentage: this.customerPercentage,
          platformPercentage: this.platformPercentage
        }
      };

      // 构造API参数，如果是赔付类型，添加compensation数据
      var apiParams = _objectSpread(_objectSpread({}, this.pram), {}, {
        outSelect: outSelect,
        orderNo: this.orderNo && this.orderNo != 0 ? this.orderNo : this.orderDetailInfo.orderNo,
        cshCardRequest: cshCardRequest,
        // 包含 cshCardRequest 对象
        costRequest: costRequest
      });

      // 80/81：如果是退货退款，后端需要 backAddressId
      // backAddressId 取 pickUpAddressId 的值，换货逻辑不变（aftersaleType==2 不处理）
      if (this.isLypOrderType && Number(this.pram.aftersaleType) === 1) {
        apiParams.backAddressId = apiParams.pickUpAddressId;
      }

      // 如果是赔付类型，添加compensationRequest数据
      if (this.pram.aftersaleType && this.pram.aftersaleType == 4 && compensationRequest) {
        apiParams.compensationRequest = compensationRequest;
      }
      aftersaleApi.createAftersale(apiParams).then(function (data) {
        _this7.$message({
          message: '创建售后成功！',
          type: 'success',
          duration: 5000 // 设置显示时间为5秒
        });
        _this7.$set(_this7.loadingInfo, 'createLoading', false);
        _this7.$closeCompletedView();
        _this7.goReturn();
      }).catch(function () {
        _this7.$message({
          message: '创建售后失败',
          type: 'error',
          duration: 5000 // 设置显示时间为5秒
        });
        _this7.$set(_this7.loadingInfo, 'createLoading', false);
      });
    },
    // 防抖处理的审核方法包装
    examineSale: function examineSale(auditStatus) {
      this.debouncedExamineSale(auditStatus);
    },
    // 原始审核方法
    _examineSale: function _examineSale(auditStatus) {
      var _this8 = this;
      console.log(auditStatus);
      // 如果是审核失败，移除退货信息和换货信息的校验规则
      if (auditStatus === 2) {
        this.$refs['createForm'].clearValidate();
      }
      // 审核通过时，手动验证退货信息/换货收货信息的必填字段
      if (auditStatus === 1 && !this.isLypOrderType) {
        var aftersaleType = Number(this.aftersaleDetails.aftersaleType);
        // 退货/换货时验证退货信息
        if ([1, 2].includes(aftersaleType)) {
          if (!this.pram.supplierAddressRealName) {
            this.$message.warning('请填写退货信息-收件人');
            return;
          }
          if (!this.pram.supplierAddressPhone) {
            this.$message.warning('请填写退货信息-收件电话');
            return;
          }
          if (!this.pram.supplierAddressDetail) {
            this.$message.warning('请填写退货信息-收件地址');
            return;
          }
        }
        // 换货时验证换货收货信息
        if (aftersaleType === 2) {
          if (!this.pram.customerAddressRealName) {
            this.$message.warning('请填写换货收货信息-收件人');
            return;
          }
          if (!this.pram.customerAddressPhone) {
            this.$message.warning('请填写换货收货信息-收件电话');
            return;
          }
          if (!this.pram.customerAddressDetail) {
            this.$message.warning('请填写换货收货信息-收件地址');
            return;
          }
        }
      }
      // 80/81：退货退款时，后端需要 backAddressId = pickUpAddressId
      if (this.isLypOrderType && Number(this.aftersaleDetails.aftersaleType) === 1) {
        this.$set(this.pram, 'backAddressId', this.pram.pickUpAddressId);
      }
      this.$refs['createForm'].validate(function (valid) {
        if (auditStatus !== 2) {
          if (!valid) return;
        }
        _this8.$set(_this8.loadingInfo, 'examineLoading', true);

        // 获取商品选择数据
        var outSelect = _this8.$refs['SeleceSalegoodsRef'] ? _this8.$refs['SeleceSalegoodsRef'].outPutSelect() || [] : [];

        // 构建 cshCardRequest 对象
        var cshCardRequest = {
          cash: _this8.pram.cashRefund ? _this8.pram.cash : 0,
          freightRefundAmount: _this8.pram.freightRefund ? _this8.pram.freightRefundAmount : 0,
          packingFeeRefundAmount: 0,
          fuCard: _this8.fucardLists.filter(function (card) {
            return _this8.checkFucard.includes(card.fucardId);
          }) // 只选择被勾选的福豆
          .map(function (card) {
            return {
              fucardId: card.fucardId,
              name: card.name,
              amount: card.refundNum
            };
          })
        };

        // 如果是审核通过，验证退款金额（非赔付、非换货类型）
        if (auditStatus === 1 && _this8.aftersaleDetails.aftersaleType !== 4 && _this8.aftersaleDetails.aftersaleType !== 2) {
          var merchantFullRefund = _this8.isMultiMerchantOrder && _this8.isMerchantGoodsFullRefund(outSelect);
          if (_this8.isMultiMerchantOrder && !merchantFullRefund) {
            cshCardRequest.freightRefundAmount = 0;
            _this8.pram.freightRefund = false;
            _this8.pram.freightRefundAmount = 0;
          }

          // 计算商品售后总金额（从商品选择组件获取编辑后的值）
          var totalAfterSaleAmount = outSelect.reduce(function (sum, item) {
            return sum + (Number(item.saleAmount) || 0);
          }, 0);

          // 计算原路退回信息输入的总金额（现金 + 福豆）
          var totalRefundAmount = Number(cshCardRequest.cash) + cshCardRequest.fuCard.reduce(function (sum, card) {
            return sum + Number(card.amount);
          }, 0);

          // 加上退回运费
          var freightRefundAmount = Number(cshCardRequest.freightRefundAmount) || 0;
          var totalAfterSaleWithFreight = totalAfterSaleAmount + freightRefundAmount;

          // 商品售后金额 + 退回运费必须与原路退回信息金额相等
          if (!_this8.isOneCardRightOrder && !merchantFullRefund && Math.abs(totalAfterSaleWithFreight - totalRefundAmount) > 0.01) {
            _this8.$message({
              message: '商品选择输入的总金额 + 退回运费必须和原路退回信息输入的总金额相等！',
              type: 'warning',
              duration: 5000
            });
            _this8.$set(_this8.loadingInfo, 'examineLoading', false);
            return;
          }
        }
        var examineParams = _objectSpread(_objectSpread({}, _this8.pram), {}, {
          auditStatus: auditStatus,
          aftersaleType: _this8.aftersaleDetails.aftersaleType,
          id: _this8.aftersaleDetails.id,
          cshCardRequest: cshCardRequest
        });

        // 仅退款/退货退款时才提交完整items（含quantity和saleAmount），其他类型不提交items
        var isRefundType = [1, 3].includes(Number(_this8.aftersaleDetails.aftersaleType));
        // 仅退款/退货退款时提交items
        if (_this8.handerType === 0 || isRefundType) {
          examineParams.items = outSelect.map(function (item) {
            return {
              orderItemId: item.orderItemId,
              skuId: item.skuId,
              quantity: item.quantity,
              saleAmount: item.saleAmount,
              orderAfsNo: item.orderAfsNo || ''
            };
          });
        }

        // 80/81：如果是退货退款，后端需要 backAddressId
        // backAddressId 取 pickUpAddressId 的值，换货逻辑不变（aftersaleType==2 不处理）
        if (_this8.isLypOrderType && Number(_this8.aftersaleDetails.aftersaleType) === 1) {
          examineParams.backAddressId = examineParams.pickUpAddressId;
        }
        // 审核通过且为退款类型时，全部退款需检查积分扣除
        var doExamineSubmit = function doExamineSubmit() {
          aftersaleApi.examineAftersale(examineParams).then(function (data) {
            _this8.$message.success('操作成功！');
            _this8.$set(_this8.loadingInfo, 'examineLoading', false);
            _this8.$closeCompletedView();
            _this8.goReturn();
          }).catch(function () {
            _this8.$set(_this8.loadingInfo, 'examineLoading', false);
          });
        };
        if (auditStatus === 1 && [1, 3].includes(Number(_this8.aftersaleDetails.aftersaleType))) {
          _this8.checkIntegralDeduction(outSelect, doExamineSubmit);
        } else {
          doExamineSubmit();
        }
      });
    },
    // 添加跟踪
    openGoNext: function openGoNext() {
      this.$refs['NextStateRef'].initOpen({
        id: this.aftersaleNo,
        statusDesc: this.aftersaleDetails.statusDesc,
        status: this.aftersaleDetails.status,
        aftersaleTypeDesc: this.aftersaleDetails.aftersaleTypeDesc,
        aftersaleType: this.aftersaleDetails.aftersaleType
      });
    },
    // 查询订单号
    searchOrder: function searchOrder() {
      var _this9 = this;
      if (!this.searchOrderNo) {
        this.$message.warning('请输入订单号查询！');
        return;
      }
      ;

      // 先获取订单详情
      this.getOrderDetail(this.searchOrderNo).then(function (res) {
        if (res && _this9.handerType === 0) {
          // 成功获取订单详情后再获取退款信息
          _this9.getRefundDetail(_this9.searchOrderNo);
        }
      });
    },
    // 获取订单详情
    getOrderDetail: function () {
      var _getOrderDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(orderNo) {
        var res, _ref, _ref$orderDelivery, orderDelivery, traces, transportStr, _ref2, status, _ref2$orderPay, orderPay, _ref3, receiverName, receiverPhone, receiverAddress, receiveTime, freight, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!orderNo || orderNo == 0)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, Promise.resolve(null));
            case 1:
              this.orderInitLoading = true;
              this.orderDetailInfo = {};
              this.returnShopIntegralDesc = null;
              _context2.p = 2;
              _context2.n = 3;
              return orderListApi.getOrderDetail(orderNo);
            case 3:
              res = _context2.v;
              _ref = res || {}, _ref$orderDelivery = _ref.orderDelivery, orderDelivery = _ref$orderDelivery === void 0 ? {} : _ref$orderDelivery;
              traces = orderDelivery.orderDeliveryList && orderDelivery.orderDeliveryList.length && orderDelivery.orderDeliveryList.map(function (item) {
                return "\u3010".concat(item.deliveryCompany, "-").concat(item.deliveryNo, "\u3011");
              }) || [];
              transportStr = traces.length && traces.join('；') || '--';
              _ref2 = res || {}, status = _ref2.status, _ref2$orderPay = _ref2.orderPay, orderPay = _ref2$orderPay === void 0 ? {} : _ref2$orderPay;
              _ref3 = res.orderDelivery || {}, receiverName = _ref3.receiverName, receiverPhone = _ref3.receiverPhone, receiverAddress = _ref3.receiverAddress, receiveTime = _ref3.receiveTime; // 从订单信息中获取运费
              freight = Number(orderPay.freight) || Number(res.freight) || 0;
              this.orderDetailInfo = _objectSpread(_objectSpread(_objectSpread({}, res), orderPay), {}, {
                freight: freight,
                // 确保运费信息被包含
                receiverNameStr: "".concat(receiverName, " \uFF08\u7535\u8BDD-").concat(receiverPhone, "\uFF09"),
                receiverAddress: receiverAddress,
                receiveTime: receiveTime,
                statusStr: this.transformState(_static.orderStateOption, Number(status), 'value'),
                payTypeStr: this.transformState(_static.payTypeOptions, Number(orderPay.payType), 'value'),
                transportStr: transportStr
              });
              this.applyLypSaleTypeLimit();
              if (this.isLypOrderType && this.orderDetailInfo && this.orderDetailInfo.userId) {
                this.getMerchantAddressOptions(this.orderDetailInfo.userId);
              } else {
                this.merchantAddressOptions = [];
              }
              // 查询到才赋值给订单信息，没查到页面提示一下没有查询到
              this.currentOrderNo = this.searchOrderNo;
              this.orderInitLoading = false;
              return _context2.a(2, res);
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              this.orderInitLoading = false;
              this.merchantAddressOptions = [];
              this.$message.error('获取订单详情失败');
              console.error(_t2);
              return _context2.a(2, null);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function getOrderDetail(_x2) {
        return _getOrderDetail.apply(this, arguments);
      }
      return getOrderDetail;
    }(),
    getMerchantAddressOptions: function getMerchantAddressOptions(userId) {
      var _this0 = this;
      if (!userId) {
        this.merchantAddressOptions = [];
        return;
      }
      this.merchantAddressLoading = true;
      aftersaleApi.getMerchantAddress(userId).then(function (res) {
        var list = Array.isArray(res) ? res : res && res.data || [];
        _this0.merchantAddressOptions = list;
      }).catch(function () {
        _this0.merchantAddressOptions = [];
      }).finally(function () {
        _this0.merchantAddressLoading = false;
      });
    },
    // 获取售后类型
    getSaleType: function getSaleType() {
      var _this1 = this;
      this.saleTypeOption = [];
      aftersaleApi.getAfterType().then(function (res) {
        _this1.saleTypeOption = res || [];
        _this1.applyLypSaleTypeLimit();
      });
    },
    applyLypSaleTypeLimit: function applyLypSaleTypeLimit() {
      if (!this.isLypOrderType) return;
      if (this.handerType === 0 && Number(this.pram && this.pram.aftersaleType) === 2) {
        this.pram.aftersaleType = null;
      }
    },
    // 获取售后详情
    getAftersaleDetail: function getAftersaleDetail() {
      var _this10 = this;
      if (!this.aftersaleNo || this.aftersaleNo == 0) return;
      this.initLoading = true;
      this.aftersaleDetails = {};
      this.returnShopIntegralDesc = null;
      aftersaleApi.getSaleDetails(this.aftersaleNo).then(function (res) {
        var _ref4 = res || {},
          _ref4$items = _ref4.items,
          items = _ref4$items === void 0 ? [] : _ref4$items,
          _ref4$supplierAddress = _ref4.supplierAddress,
          supplierAddress = _ref4$supplierAddress === void 0 ? {} : _ref4$supplierAddress,
          _ref4$customerAddress = _ref4.customerAddress,
          customerAddress = _ref4$customerAddress === void 0 ? {} : _ref4$customerAddress,
          id = _ref4.id,
          aftersaleType = _ref4.aftersaleType,
          _ref4$logisticsRespon = _ref4.logisticsResponses,
          logisticsResponses = _ref4$logisticsRespon === void 0 ? [] : _ref4$logisticsRespon,
          _ref4$deliveryLogisti = _ref4.deliveryLogisticsResponse,
          deliveryLogisticsResponse = _ref4$deliveryLogisti === void 0 ? [] : _ref4$deliveryLogisti,
          _ref4$cash = _ref4.cash,
          cash = _ref4$cash === void 0 ? 0 : _ref4$cash,
          _ref4$points = _ref4.points,
          points = _ref4$points === void 0 ? 0 : _ref4$points,
          couponId = _ref4.couponId,
          _ref4$couponUseRespon = _ref4.couponUseResponseList,
          couponUseResponseList = _ref4$couponUseRespon === void 0 ? [] : _ref4$couponUseRespon,
          cashCardRequest = _ref4.cashCardRequest,
          pickUpAddressId = _ref4.pickUpAddressId,
          backAddressId = _ref4.backAddressId,
          pickUpType = _ref4.pickUpType,
          returnShopIntegralDesc = _ref4.returnShopIntegralDesc,
          status = _ref4.status;
        _this10.currentitem = items;
        var couponStr = '';
        if (couponId && couponUseResponseList && couponUseResponseList.length) {
          var copList = couponUseResponseList.map(function (item) {
            return item.couponName;
          });
          couponStr = copList.join('；') || '';
        }
        ;
        // 构建包含所有福豆信息的字符串
        var fuCardStr = "";
        if (cashCardRequest && cashCardRequest.fuCard) {
          fuCardStr = cashCardRequest.fuCard.map(function (card) {
            return "".concat(card.name, "\uFF1A").concat(card.amount);
          }).join('，');
        }
        if (!cash && cashCardRequest && cashCardRequest.cash && cashCardRequest.cash > 0) {
          cash = cashCardRequest.cash || 0;
        }
        _this10.aftersaleDetails = _objectSpread(_objectSpread({}, res), {}, {
          skuItems: items && items.length && items.map(function (value) {
            return _objectSpread(_objectSpread({}, value), {}, {
              skuAttr: value.attr,
              skuQuantity: value.quantity,
              saleQty: value.quantity,
              skuPrice: value.price
            });
          }),
          refundStr: "\u73B0\u91D1\uFF1A".concat(cash || 0, "\uFF1B\u798F\u8C46\uFF1A").concat(fuCardStr || '无', "\uFF1B").concat(couponStr ? "\u5361\u5238\uFF1A".concat(couponStr, "\uFF1B") : '').concat(cashCardRequest && Number(cashCardRequest.returnShopIntegral) > 0 ? "\u79EF\u5206\uFF1A".concat(cashCardRequest.returnShopIntegral, "\uFF1B") : '').concat(cashCardRequest && Number(cashCardRequest.refundIntegral) > 0 ? "\u79EF\u5206\u56DE\u6536\uFF1A".concat(cashCardRequest.refundIntegral) : ''),
          refundTransportStateStr: logisticsResponses && logisticsResponses.length ? "".concat(logisticsResponses[0].trackingNumber || '', "  ").concat(logisticsResponses[0].logisticsCompanyName || '', " ").concat(logisticsResponses[0].stateMsg ? "\u3010".concat(logisticsResponses[0].stateMsg, "\u3011") : '') : '',
          refundTransportList: _this10._transportTrace(logisticsResponses),
          sendTransportStateStr: deliveryLogisticsResponse && deliveryLogisticsResponse.length ? "".concat(deliveryLogisticsResponse[0].trackingNumber || '', "  ").concat(deliveryLogisticsResponse[0].logisticsCompanyName || '', " ").concat(deliveryLogisticsResponse[0].stateMsg ? "\u3010".concat(deliveryLogisticsResponse[0].stateMsg, "\u3011") : '') : '',
          sendTransportList: _this10._transportTrace(deliveryLogisticsResponse)
        });
        if (status && (status === 9 || status === 8)) {
          _this10.aftersaleDetails.refundStr = '-';
        }
        _this10.returnShopIntegralDesc = returnShopIntegralDesc !== undefined && returnShopIntegralDesc !== null ? returnShopIntegralDesc : null;

        // 计算订单总价 = 积分抵扣 + 订单实付款
        var useIntegral = Number(res.useIntegral) || 0;
        var paidPrice = Number(res.paidPrice) || 0;
        _this10.aftersaleDetails.orderTotalPrice = (useIntegral + paidPrice).toFixed(2);
        _this10.pram = {
          cash: Number(cash || 0),
          points: Number(points || 0),
          couponId: couponId && couponId.length ? couponId : [],
          notifyType: [],
          id: id,
          adminReason: '',
          cashRefund: false,
          maxCash: 0,
          pickUpAddressId: pickUpAddressId != null ? pickUpAddressId : null,
          backAddressId: backAddressId != null ? backAddressId : null,
          pickUpType: pickUpType != null ? pickUpType : null,
          supplierAddressRealName: '',
          supplierAddressPhone: '',
          supplierAddressDetail: '',
          customerAddressRealName: '',
          customerAddressPhone: '',
          customerAddressDetail: ''
        };
        // 类型为换货时才展示: 换货收货地址
        if (aftersaleType == 2 && customerAddress) {
          _this10.pram = _objectSpread(_objectSpread({}, _this10.pram), {}, {
            customerAddressRealName: customerAddress.realName,
            customerAddressPhone: customerAddress.phone,
            customerAddressDetail: customerAddress.detail
          });
        }
        ;
        // 类型为退货/换货时才展示: 退货信息
        if ([1, 2].includes(aftersaleType) && supplierAddress) {
          _this10.pram = _objectSpread(_objectSpread({}, _this10.pram), {}, {
            supplierAddressRealName: supplierAddress.realName,
            supplierAddressPhone: supplierAddress.phone,
            supplierAddressDetail: supplierAddress.detail
          });
        }

        // 处理原路退回信息 - 从cashCardRequest中获取
        if (_this10.handerType === 1 && cashCardRequest) {
          // 设置现金退款信息
          if (cashCardRequest.cash && Number(cashCardRequest.cash) > 0) {
            _this10.pram.cashRefund = true;
            _this10.pram.cash = Number(cashCardRequest.cash);
            _this10.pram.maxCash = Number(cashCardRequest.cash); // 审核时，最大值就是当前值
          }

          // 设置福豆退款信息
          if (cashCardRequest.fuCard && cashCardRequest.fuCard.length > 0) {
            // 转换福豆信息格式
            _this10.fucardLists = cashCardRequest.fuCard.map(function (card) {
              return {
                fucardId: card.fucardId,
                name: card.name,
                price: Number(card.amount) || 0,
                // 使用amount作为最大退还金额
                refundNum: Number(card.amount) || 0,
                // 初始值设为最大值
                checked: true // 默认选中
              };
            });

            // 更新选中的福豆ID列表
            _this10.checkFucard = _this10.fucardLists.map(function (card) {
              return card.fucardId;
            });
          }
        }

        // 更新预计金额
        if (res.responsibility) {
          _this10.supplierAmount = res.responsibility.supplierAmount;
          _this10.customerAmount = res.responsibility.customerAmount;
          _this10.platformAmount = res.responsibility.platformAmount;
          _this10.supplierPercentage = res.responsibility.supplierPercentage;
          _this10.customerPercentage = res.responsibility.customerPercentage;
          _this10.platformPercentage = res.responsibility.platformPercentage;
        }
        _this10.initLoading = false;
      }).catch(function (err) {
        _this10.initLoading = false;
      });
    },
    _transportTrace: function _transportTrace() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return list && list.length && list.map(function (item) {
        var _ref5 = item || {},
          logisticsCompanyName = _ref5.logisticsCompanyName,
          stateMsg = _ref5.stateMsg,
          trackingNumber = _ref5.trackingNumber,
          _ref5$statusRecords = _ref5.statusRecords,
          statusRecords = _ref5$statusRecords === void 0 ? [] : _ref5$statusRecords;
        return {
          deliveryName: logisticsCompanyName,
          nu: trackingNumber,
          stateMsg: stateMsg,
          data: statusRecords && statusRecords.length && statusRecords.map(function () {
            var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return _objectSpread(_objectSpread({}, val), {}, {
              time: val.statusTime,
              context: val.statusDescription
            });
          })
        };
      });
    },
    openRefundTransport: function openRefundTransport() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.$refs.TransportTraceRef.initOpen(list);
    },
    // 弹窗打开订单详情
    goToOrderDetail: function goToOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    // 打开审核驳回弹窗
    openRejectDialog: function openRejectDialog() {
      this.rejectDialog.adminReason = '';
      this.rejectDialog.visible = true;
    },
    // 确认审核驳回
    confirmReject: function confirmReject() {
      if (this.loadingInfo.examineLoading) {
        return;
      }
      if (!this.rejectDialog.adminReason) {
        this.$message.warning('请填写驳回原因');
        return;
      }
      this.pram.adminReason = this.rejectDialog.adminReason;
      // 关闭弹窗
      this.rejectDialog.visible = false;

      // 调用审核方法，传入审核状态为2（驳回）
      this.examineSale(2);
    },
    // 获取退款详情（包括福豆信息）
    getRefundDetail: function getRefundDetail(orderNo) {
      var _this11 = this;
      aftersaleApi.getRefundDetail(orderNo).then(function (response) {
        if (response) {
          var _this11$orderDetailIn;
          var maxCash = response.maxCash,
            fuCard = response.fuCard,
            freightRefundAmount = response.freightRefundAmount,
            returnShopIntegralDesc = response.returnShopIntegralDesc;

          // 确保 pram 已初始化
          if (!_this11.pram) {
            _this11.pram = {
              cashRefund: false,
              freightRefund: false,
              freightRefundAmount: 0,
              cash: 0,
              points: 0,
              couponId: [],
              notifyType: []
            };
          }
          _this11.pram.maxCash = maxCash || 0;
          _this11.returnShopIntegralDesc = returnShopIntegralDesc !== undefined && returnShopIntegralDesc !== null ? returnShopIntegralDesc : null;
          // 从订单详情中获取运费信息
          _this11.pram.maxFreight = Number((_this11$orderDetailIn = _this11.orderDetailInfo.orderPay) === null || _this11$orderDetailIn === void 0 ? void 0 : _this11$orderDetailIn.freight) || Number(_this11.orderDetailInfo.freight) || 0;
          // 保存接口返回的已退运费金额
          _this11.pram.freightRefundAmountApi = Number(freightRefundAmount) || 0;
          if (fuCard && fuCard.length !== 0) {
            _this11.fucardLists = fuCard.map(function (card) {
              return {
                fucardId: card.id,
                name: card.name,
                price: card.maxAmount || 0,
                refundNum: 0,
                // 初始化退款数量为0
                checked: false // 初始化选中状态为false
              };
            });
          } else {
            _this11.fucardLists = [];
            _this11.checkFucard = [];
          }
        }
      }).catch(function (error) {
        _this11.returnShopIntegralDesc = null;
        console.error('获取退款详情出错:', error);
        _this11.$message.error('获取退款详情出错');
      });
    },
    handleFuCardChange: function handleFuCardChange(item) {
      if (!item) return;
      item.checked = !item.checked; // 切换勾选状态
      if (item.checked) {
        item.refundNum = item.price || 0; // 勾选时设置为最高退还金额
      } else {
        item.refundNum = 0; // 取消勾选时设为0
      }
    },
    handleCashRefundChange: function handleCashRefundChange() {
      if (!this.pram) return;
      if (this.pram.cashRefund) {
        this.pram.cash = this.pram.maxCash || 0; // 勾选时设置为最高退还金额
      } else {
        this.pram.cash = 0; // 取消勾选时设为0
      }
    },
    // 处理运费退款勾选变更
    handleFreightRefundChange: function handleFreightRefundChange() {
      if (!this.pram) return;
      if (this.pram.freightRefund) {
        this.pram.freightRefundAmount = this.orderDetailInfo.freight || 0; // 勾选时设置为最高退还金额
      } else {
        this.pram.freightRefundAmount = 0; // 取消勾选时设为0
      }
    },
    // 判断是否全部退款（商品全部退款 + 原路退款信息全部退，才视为全部退款）
    // 多次退款表示非全部退款：任一商品已有退款记录（afterSalePriceTotal > 0）则不算全部退款
    isMerchantGoodsFullRefund: function isMerchantGoodsFullRefund(outSelect) {
      if (!this.isMultiMerchantOrder) return false;
      var orderItems = this.orderDetailInfo.orderItemList || [];
      if (!orderItems.length || !outSelect.length) return false;
      return orderItems.every(function (orderItem) {
        var orderItemId = Number(orderItem.id || orderItem.orderItemId);
        var selectedAmount = outSelect.filter(function (item) {
          return Number(item.orderItemId || item.id) === orderItemId;
        }).reduce(function (sum, item) {
          return sum + (Number(item.saleAmount) || 0);
        }, 0);
        var historyAmount = Number(orderItem.afterSalePriceTotal) || 0;
        var maxRefundAmount = Math.max(0, (Number(orderItem.skuTotalPrice) || 0) - (Number(orderItem.skuCouponPrice) || 0) - (Number(orderItem.payShopIntegralPrice) || 0));
        return historyAmount + selectedAmount >= maxRefundAmount - 0.01;
      });
    },
    isFullRefund: function isFullRefund(outSelect) {
      var orderItems = this.orderDetailInfo.orderItemList || [];
      if (!orderItems.length || !outSelect.length) return false;
      if (this.isMerchantGoodsFullRefund(outSelect)) return true;
      // 创建售后时，多次退款天然表示非全部退款；审核售后时不校验（afterSalePriceTotal天然大于0）
      if (this.handerType === 0) {
        var hasPreviousRefund = orderItems.some(function (item) {
          return Number(item.afterSalePriceTotal) > 0;
        });
        if (hasPreviousRefund) return false;
      }
      // ========== 1. 商品售后金额 + 运费 == 订单实付总额 ==========
      var totalItemPaid = 0;
      var _iterator = _createForOfIteratorHelper(orderItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var skuTotalPrice = Number(item.skuTotalPrice) || 0;
          var skuCouponPrice = Number(item.skuCouponPrice) || 0;
          var payShopIntegralPrice = Number(item.payShopIntegralPrice) || 0;
          totalItemPaid += skuTotalPrice - skuCouponPrice - payShopIntegralPrice;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var orderFreight = Number(this.orderDetailInfo.freight) || 0;
      var totalOrderPaid = totalItemPaid + orderFreight;
      var freightRefundAmount = Number(this.pram.freightRefundAmount) || 0;
      var totalAfterSaleAmount = outSelect.reduce(function (sum, item) {
        return sum + (Number(item.saleAmount) || 0);
      }, 0);
      var totalRefund = totalAfterSaleAmount + freightRefundAmount;
      if (!(totalOrderPaid > 0 && Math.abs(totalRefund - totalOrderPaid) < 0.01)) return false;
      // ========== 2. 原路退款信息必须全部退 ==========
      // 现金：勾选且金额等于最大可退
      var maxCash = Number(this.pram.maxCash) || 0;
      if (maxCash > 0 && (!this.pram.cashRefund || Math.abs(Number(this.pram.cash) - maxCash) > 0.01)) {
        return false;
      }
      // 福豆：所有福豆都勾选且退款金额等于最高退还金额
      if (this.fucardLists.length > 0) {
        var allFuCardFull = this.fucardLists.every(function (card) {
          return card.checked && Math.abs(Number(card.refundNum) - Number(card.price)) < 0.01;
        });
        if (!allFuCardFull) return false;
      }
      // 运费：有运费时必须勾选且金额等于运费
      if (orderFreight > 0 && (!this.pram.freightRefund || Math.abs(Number(this.pram.freightRefundAmount) - orderFreight) > 0.01)) {
        return false;
      }
      // 卡券：所有卡券都已选中
      var couponList = this.handerType === 0 ? this.orderDetailInfo.couponUseResponse || [] : this.aftersaleDetails.couponUseResponseList || [];
      if (couponList.length > 0 && (!this.pram.couponId || this.pram.couponId.length !== couponList.length)) {
        return false;
      }
      return true;
    },
    // 计算选中商品的返积分之和
    getGiveIntegralSum: function getGiveIntegralSum(outSelect) {
      var orderItems = this.orderDetailInfo.orderItemList || [];
      return outSelect.reduce(function (sum, item) {
        var orderItem = orderItems.find(function (oi) {
          return oi.skuId === item.skuId;
        });
        var giveIntegral = orderItem ? Number(orderItem.giveIntegral) || 0 : 0;
        return sum + giveIntegral;
      }, 0);
    },
    // 全部退款时检查积分扣除，如需扣除积分大于剩余可用积分则弹窗提示并阻止提交
    checkIntegralDeduction: function checkIntegralDeduction(outSelect, callback) {
      if (!this.isFullRefund(outSelect)) {
        callback();
        return;
      }
      var remainIntegral = this.orderDetailInfo.remainIntegral;
      // 如果接口未返回剩余可用积分，则不做积分扣除检查
      if (remainIntegral === null || remainIntegral === undefined) {
        callback();
        return;
      }
      var giveIntegralSum = this.getGiveIntegralSum(outSelect);
      if (giveIntegralSum > Number(remainIntegral)) {
        this.integralConfirmDialog.visible = true;
        // 弹窗提示意味着阻止提交，重置loading状态取消防抖效果
        this.$set(this.loadingInfo, 'examineLoading', false);
        this.$set(this.loadingInfo, 'createLoading', false);
      } else {
        callback();
      }
    },
    // 提交责任判定
    submitResponsibility: function submitResponsibility() {
      var _this12 = this;
      // 获取当前选中的商品及其数量
      var orderAftersaleItemRequest = null;
      if (this.handerType === 1) {
        var _this$$refs$SeleceSal;
        // 审核售后时从商品选择组件获取编辑后的数据
        orderAftersaleItemRequest = ((_this$$refs$SeleceSal = this.$refs['SeleceSalegoodsRef']) === null || _this$$refs$SeleceSal === void 0 ? void 0 : _this$$refs$SeleceSal.outPutSelect()) || [];
      } else {
        var _this$$refs$SeleceSal2;
        // 创建售后时使用用户选择的商品
        orderAftersaleItemRequest = ((_this$$refs$SeleceSal2 = this.$refs['SeleceSalegoodsRef']) === null || _this$$refs$SeleceSal2 === void 0 ? void 0 : _this$$refs$SeleceSal2.outPutSelect()) || [];
      }
      if (orderAftersaleItemRequest.length === 0) {
        console.warn('没有选择售后商品，无法计算责任判定');
        return;
      }
      var totalPercentage = this.supplierPercentage + this.customerPercentage + this.platformPercentage;
      // 检查三个百分比之和是否超过100
      if (totalPercentage > 100) {
        this.$message.error('供应商、客户和平台的百分比之和不能超过100');
        return; // 阻止提交
      }
      var request = {
        orderAftersaleItemRequest: orderAftersaleItemRequest,
        responsibility: {
          supplierPercentage: this.supplierPercentage,
          customerPercentage: this.customerPercentage,
          platformPercentage: this.platformPercentage
        }
      };
      aftersaleApi.getCost(request).then(function (response) {
        // 更新预计金额
        _this12.supplierAmount = response.supplierAmount;
        _this12.customerAmount = response.customerAmount;
        _this12.platformAmount = response.platformAmount;
        _this12.aftersaleCostAmount = response.aftersaleCostAmount;
      }).catch(function (error) {
        console.error('调用售后判责接口出错:', error);
        _this12.$message.error('售后判责失败');
      });
    },
    handleSaleDataChanged: function handleSaleDataChanged(data) {
      var _this13 = this;
      // 同步当前勾选商品的 skuId，用于动态计算取件方式选项
      this.selectedSkuIds = (data || []).map(function (item) {
        return String(item.skuId);
      }).filter(Boolean);
      // 若当前已选的 pickUpType 在新选项中不合法则重置
      if (this.pram.pickUpType !== null) {
        var validValues = this.pickUpTypeOptions.map(function (o) {
          return o.value;
        });
        if (!validValues.includes(this.pram.pickUpType)) {
          this.pram.pickUpType = null;
        }
      }
      // 处理子组件发出的 'dataChanged' 事件
      if (data && data.length) {
        // 获取当前选中的商品信息
        var selectedItems = this.$refs['SeleceSalegoodsRef'].outPutSelect() || [];

        // 如果是创建售后页面且有选中商品，通过接口获取退款信息
        if (this.handerType === 0 && selectedItems.length > 0) {
          // 获取订单号
          var orderNoToUse = this.orderNo || this.currentOrderNo;
          if (orderNoToUse) {
            // 调用获取退款详情接口
            aftersaleApi.getRefundDetail(orderNoToUse).then(function (response) {
              var maxCash = response.maxCash,
                fuCard = response.fuCard,
                returnShopIntegralDesc = response.returnShopIntegralDesc;

              // 更新最大现金退款金额
              _this13.pram.maxCash = maxCash;
              _this13.returnShopIntegralDesc = returnShopIntegralDesc !== undefined && returnShopIntegralDesc !== null ? returnShopIntegralDesc : null;

              // 如果已勾选现金退款，自动更新为新的最大值
              if (_this13.pram.cashRefund) {
                _this13.pram.cash = maxCash;
              }

              // 更新福豆信息
              if (fuCard && fuCard.length) {
                // 保存当前已选中和输入的退款信息
                var currentFucards = _toConsumableArray(_this13.fucardLists);
                _this13.fucardLists = fuCard.map(function (card) {
                  // 查找当前对应的福豆
                  var existingCard = currentFucards.find(function (c) {
                    return c.fucardId === card.id;
                  });
                  return {
                    fucardId: card.id,
                    name: card.name,
                    price: card.maxAmount,
                    // 保留已填写的值，但不超过新的最大值
                    refundNum: existingCard !== null && existingCard !== void 0 && existingCard.checked ? Math.min(existingCard.refundNum || 0, card.maxAmount) : 0,
                    checked: (existingCard === null || existingCard === void 0 ? void 0 : existingCard.checked) || false
                  };
                });

                // 更新选中的福豆ID列表
                _this13.checkFucard = _this13.fucardLists.filter(function (card) {
                  return card.checked;
                }).map(function (card) {
                  return card.fucardId;
                });
              }
              if (!fuCard || !fuCard.length) {
                _this13.fucardLists = [];
                _this13.checkFucard = [];
              }
            }).catch(function (error) {
              console.error('获取退款详情出错:', error);
            });
          }

          // 更新责任判定
          this.submitResponsibility();
        }

        // 如果是审核售后页面且有选中商品，更新责任判定
        if (this.handerType === 1 && selectedItems.length > 0) {
          this.submitResponsibility();
        }
      }
    },
    getRejectReason: function getRejectReason() {
      if (this.aftersaleDetails.trackingLogs && this.aftersaleDetails.trackingLogs.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(this.aftersaleDetails.trackingLogs),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var log = _step2.value;
            var desc = log.description;
            if (desc && desc.includes('原因：')) {
              var _desc$split$;
              // 提取 "原因：" 后面的内容并去除前后空格
              var reason = (_desc$split$ = desc.split('原因：')[1]) === null || _desc$split$ === void 0 ? void 0 : _desc$split$.trim();
              if (reason) {
                return reason;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return '';
    }
  }
};